import { useSearchParams } from "react-router-dom";
import ITDeclaration from "./ITDeclaration";
import ProofOfInvestments from "./ProofOfInvestments";
import { Listbox } from "@headlessui/react";
import { MdFilterAlt, MdKeyboardArrowDown } from "react-icons/md";
import { useState } from "react";
import useTdsData from "../../../hooks/useTdsData";
import PrimaryLoader from "../../../components/common/PrimaryLoader";

const InvestmentsAndProofs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  // Determine active tab
  const isPOI = tab === "poi";
  const isITDeclaration = !isPOI; // default to IT Declaration

  const {
    tdsData,
    isLoading,
    financialYearOptions,
    selectedFinancialYear,
    handleFinancialYearChange,
    hasDeclarations,
  } = useTdsData();

  // Handle tab click to update query param
  const handleTabClick = (tabValue) => {
    if (tabValue) {
      setSearchParams({ tab: tabValue });
    } else {
      setSearchParams({});
    }
  };

  if (isLoading || !selectedFinancialYear) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <PrimaryLoader />
      </div>
    );
  }

  return (
    <div className="pt-5">
      <div className="flex items-center px-5 border-b border-gray-200 py-1 mt-10">
        <ul className="flex items-center space-x-3 text-gray-600">
          <li
            className={isITDeclaration ? "active" : ""}
            style={{ cursor: "pointer" }}
            onClick={() => handleTabClick("")}
          >
            IT Declaration
          </li>
          <li
            className={isPOI ? "active" : ""}
            style={{ cursor: "pointer" }}
            onClick={() => handleTabClick("poi")}
          >
            Proof of Investments
          </li>
        </ul>
        {/* Divider and Year Dropdown */}
        <div className="flex items-center ml-6">
          <div className="h-6 border-l border-gray-300 mx-4" />
          <div className="relative">
            <Listbox value={selectedFinancialYear} onChange={handleFinancialYearChange}>
              {({ open }) => (
                <>
                  <Listbox.Button className="flex items-center gap-2 px-3 py-1.5  text-gray-700 text-sm font-medium focus:outline-none">
                    <MdFilterAlt className="text-gray-400 w-4 h-4" />
                    <span className="text-gray-600">Period :</span>
                    <span className="ml-1 font-semibold text-gray-900">
                      {selectedFinancialYear.label}
                    </span>
                    <MdKeyboardArrowDown className="ml-1 w-4 h-4 text-gray-400" />
                  </Listbox.Button>
                  {open && (
                    <div className="absolute right-0 mt-2 w-48 rounded shadow-lg border border-gray-200 bg-white z-10">
                      <Listbox.Options static className="p-2">
                        {financialYearOptions.map((option) => (
                          <Listbox.Option
                            key={option.value}
                            value={option}
                            className={({ active, selected }) =>
                              `cursor-pointer px-4 py-3 text-base rounded transition-colors ${
                                selected
                                  ? "bg-blue-500 text-white"
                                  : active
                                  ? "bg-blue-50 text-blue-700"
                                  : "text-gray-900"
                              }`
                            }
                          >
                            {option.label}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </div>
                  )}
                </>
              )}
            </Listbox>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {isITDeclaration && <ITDeclaration tdsData={tdsData} hasDeclarations={hasDeclarations} />}
        {isPOI && <ProofOfInvestments tdsData={tdsData} hasDeclarations={hasDeclarations} />}
      </div>
    </div>
  );
};

export default InvestmentsAndProofs;
